/** 時間倍率の目標値（docs/02_architecture.md 7 章）。なめらかな補間は app が現実時間で行う */
import { TIME } from '../../config/balance';
import type { RaceState } from '../types';

export function targetTimeScale(race: RaceState): number {
  if (race.phase === 'planning' || race.phase === 'dayEnd' || race.phase === 'finished') return 0;
  if (race.pause) return 0;
  let s = TIME.baseScale * race.fastForward;
  if (race.editing) s *= TIME.editSlow;
  return s;
}
